module.exports = __webpack_public_path__ + "img/nicard-logo-part-2.929a7815.png";